// iter 275 round 33 — helper URL condivisi tra FotoEditor e GalleriaFoto.
// Pure extract dal vecchio FotoEditor.jsx (era duplicato in GalleriaFoto inline).
// Nessuna logica di stato qui: solo costruzione URL token-authenticated per
// accedere ai file protetti del backend (live previews + foto annunci).

import Cookies from "js-cookie";
import { API } from "@/lib/api";

/**
 * Risolve l'URL di un item della galleria unificata (live + property photos).
 * Items returned by /api/gallery come with `url` already pointing at the
 * right backend route (`/api/live/file` or `/api/files`).
 * Appende ?auth=<jwt> così il browser può scaricare i file protetti senza
 * dover usare `credentials: include` (che su iOS Safari ITP fallisce).
 */
export function galleryItemUrl(item) {
  const rawUrl = item?.url || item?.enhanced_url || item?.image_url || "";
  if (!rawUrl) return "";
  const token = Cookies.get("vista_jwt");
  const sep = rawUrl.includes("?") ? "&" : "?";
  const tokenParam = token ? `${sep}auth=${token}` : "";
  // rawUrl already starts with /api/... — strip the leading /api because
  // API constant ends with /api too.
  const cleanPath = rawUrl.startsWith("/api/") ? rawUrl.slice(4) : rawUrl;
  return `${API}${cleanPath}${tokenParam}`;
}

/** URL per la versione before/after di una live preview. */
export function liveFileUrl(id, kind = "after") {
  const token = Cookies.get("vista_jwt");
  const qs = new URLSearchParams({ id, kind });
  if (token) qs.append("auth", token);
  return `${API}/live/file?${qs.toString()}`;
}

/** PNG 1080×1080 share-ready con BEFORE/AFTER affiancati. */
export function liveBeforeAfterCardUrl(id) {
  const token = Cookies.get("vista_jwt");
  const qs = new URLSearchParams({ id });
  if (token) qs.append("auth", token);
  return `${API}/live/before-after-card?${qs.toString()}`;
}

/** MP4 reel before/after (slider o split). */
export function liveBeforeAfterVideoUrl(id, style = "slider") {
  const token = Cookies.get("vista_jwt");
  const qs = new URLSearchParams({ id, style });
  if (token) qs.append("auth", token);
  return `${API}/live/before-after-video?${qs.toString()}`;
}
